//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../Features/Features.Subdivision.SubdivisionBodyCollection.js";
let d=[[],[[["seedData","numEntities"],"Collect",{R_:{entities:"DisplayableObject[]"}},1,0]],[]];
SPLM.Features.Subdivision.SelectionIntent = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.Subdivision.SelectionIntent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.SelectionIntent.SeedData = class{
    constructor(rule,seed1,seed2,cursorLocation,viewDirection){
        this.rule=rule;this.seed1=seed1;this.seed2=seed2;this.cursorLocation=cursorLocation;this.viewDirection=viewDirection;}
    get Rule(){return this.rule}
    set Rule(val){this.rule = val}
    get Seed1(){return this.seed1}
    set Seed1(val){this.seed1 = val}
    get Seed2(){return this.seed2}
    set Seed2(val){this.seed2 = val}
    get Cursorlocation(){if(this.cursorLocation === undefined) this.cursorLocation = new SPLM.Point3d(); return this.cursorLocation}
    set Cursorlocation(val){this.cursorLocation = val}
    get Viewdirection(){if(this.viewDirection === undefined) this.viewDirection = new SPLM.Vector3d(); return this.viewDirection}
    set Viewdirection(val){this.viewDirection = val}
};

SPLM.Features.Subdivision.SelectionIntent.Rule = Object.freeze({
    "Single" : "Single", "Loop" : "Loop", "Matrix" : "Matrix", "Region" : "Region", "SharpEdges" : "SharpEdges", "WeightedEdges" : "WeightedEdges", "ConnectedSharpEdges" : "ConnectedSharpEdges", "ConnectedWeightedEdges" : "ConnectedWeightedEdges"});

export default SPLM;